<template>
  <div>
    <div v-if="items.length === 0" class="ret-no-content-icon">
      <v-icon flat x-large>no_sim</v-icon>
    </div>

    <div v-for="(item, index) in items" :key="item.id">
      <div v-if="dayDividers && (daysDiff(index) || index === 0)" class="ret-middle-above-card">
        <div v-if="weeksDiff(index)">
          <v-icon>today</v-icon>
        </div>
        {{ item.actionAt | dateListDelimiters }}
      </div>
      <issue-card
        :item="item"
        :showAsset="showAsset"
        :dayDividers="dayDividers"
        @click="onClick">
      </issue-card>
    </div>
  </div>
</template>

<script>
import displayHelpers from '../../helpers/display-helpers.es6'
import comps from '../../helpers/computations.es6'
import IssueCard from './issue-card.vue'

export default {
  name: 'issues-list',
  mixins: [displayHelpers],
  props: {
    items: Array,
    showAsset: {
      type: Boolean,
      default: false
    },
    dayDividers: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // Computations
    daysDiff (index) {
      const dates = this.items.map(item => item.actionAt)
      return comps.diffFromPreviousDate(dates, index)
    },
    weeksDiff (index) {
      const dates = this.items.map(item => item.actionAt)
      return comps.diffFromPreviousDate(dates, index, 'week')
    },
    // Routings
    onClick (item) {
      this.$router.push({ name: `issues/id`, params: { id: item.id } })
    }
  },
  components: {
    IssueCard
  }
}
</script>
